/*=============================================
=            Table Body styling            =
=============================================*/

:host {
  @apply relative flex;

  &.pk-table--body {
    @apply w-full flex-col;

    &.fixed-width {
      @apply w-max;
    }
  }
}

.pk-table--body-loader {
  @apply absolute z-[-1] flex h-full w-full items-center justify-center bg-elevation-01 opacity-0 transition-opacity duration-250;

  &.is-loading {
    @apply z-[5] opacity-100;
  }
}
